export default __webpack_public_path__ + "static/media/image-map-australia.3afe58f8.png";